"use client"

import type { SVGMotionProps } from "motion/react"
import { forwardRef } from "react"
import { motion } from "motion/react"

type Props = SVGMotionProps<object> & {
	fill?: string
}
export const ProductlaneIcon = forwardRef<SVGSVGElement, Props>(
	({ fill = "#16BDCA", ...props }, ref) => {
		return (
			<motion.svg
				viewBox="0 0 17 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				ref={ref}
				{...props}
			>
				<motion.path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.07162 0C6.77886 0 6.51493 0.176352 6.4029 0.446825C6.29086 0.717297 6.35279 1.02862 6.5598 1.23563L8.92533 3.60116L4.01411 8.51237C3.87837 8.64812 3.80211 8.83222 3.80211 9.02419V13.0404L2.16044 11.3987C1.95343 11.1917 1.6421 11.1298 1.37163 11.2418C1.10116 11.3539 0.924805 11.6178 0.924805 11.9105V20.5515C0.924805 20.9513 1.24887 21.2754 1.64862 21.2754H10.2896C10.5824 21.2754 10.8463 21.099 10.9583 20.8285C11.0704 20.5581 11.0084 20.2467 10.8014 20.0397L8.43591 17.6742L13.3471 12.763C13.4829 12.6272 13.5591 12.4431 13.5591 12.2512V8.2388L15.2 9.88479C15.4068 10.0923 15.7183 10.1546 15.9891 10.0427C16.2598 9.93081 16.4364 9.66673 16.4364 9.37377V0.723818C16.4364 0.324064 16.1124 0 15.7126 0H7.07162ZM4.01145 15.297C4.02032 15.306 4.02944 15.3147 4.03879 15.3232C4.32274 15.582 4.76287 15.5743 5.03751 15.3L12.1115 8.23364V11.9514L6.90046 17.1624C6.61779 17.445 6.61779 17.9033 6.90046 18.186L8.54217 19.8277H2.37244V13.658L4.01145 15.297ZM10.4608 3.08934L8.81907 1.44764H14.9888V7.62247L13.3479 5.97645C13.2123 5.8404 13.0281 5.76385 12.836 5.76365C12.6439 5.76345 12.4596 5.83962 12.3237 5.97538L5.24975 13.0417V9.32401L10.4608 4.11298C10.7434 3.83031 10.7434 3.37201 10.4608 3.08934Z"
					fill={fill}
				/>
			</motion.svg>
		)
	},
)
